import { Phone, CreditCard, Rocket } from "lucide-react";

const steps = [
    { icon: Phone, num: "01", title: "Free strategy call", desc: "30 minutes. Goals, audit, best-fit package." },
    { icon: CreditCard, num: "02", title: "Secure payment", desc: "Stripe checkout. Instant calendar access after." },
    { icon: Rocket, num: "03", title: "First content in 7 days", desc: "Onboarding, shoot, first drop &mdash; that fast." },
];

export default function Process() {
    return (
        <section id="process" className="relative py-24 sm:py-32 border-t border-white/10 bg-[#0d0d0f]">
            <div className="max-w-7xl mx-auto px-5 sm:px-8">
                <div className="mb-16">
                    <div className="eyebrow mb-4 flex items-center gap-3">
                        <span className="inline-block w-10 h-[2px] bg-brand" /> How it works
                    </div>
                    <h2 className="font-display font-medium tracking-[-0.04em] text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.02] max-w-3xl">
                        Three steps.<br />
                        <span className="text-white/40">Zero friction.</span>
                    </h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
                    {steps.map((s) => {
                        const Icon = s.icon;
                        return (
                            <div key={s.num} className="relative bg-[#141414] border border-white/10 p-8 group hover:border-brand/50 transition-colors">
                                <div className="flex items-center justify-between mb-8">
                                    <Icon className="w-7 h-7 text-brand" />
                                    <span className="numeric-display font-semibold text-6xl text-white/[0.06] group-hover:text-white/10 transition-colors">
                                        {s.num}
                                    </span>
                                </div>
                                <h3 className="font-display font-medium text-2xl text-white tracking-[-0.02em]">{s.title}</h3>
                                <p
                                    className="mt-3 text-white/60 leading-relaxed text-sm"
                                    dangerouslySetInnerHTML={{ __html: s.desc }}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
